import { IChartColor } from '../models';

// TODO: Include all chart types
export enum CHART_TYPE {
  DONUT,
  PIE,
  SEMI_CIRCLE,
  SINGLE_BAR,
  GROUPED_BAR,
  BOX_PLOT,
  STACKED_BAR,
  LINE
}

export enum DATA_TYPE {
  UPPER_QUARTILE,
  LOWER_QUARTILE,
  UPPER_DECILE,
  LOWER_DECILE,
  MEDIAN,
  CUSTOM_POINT,
  RANGE_START,
  RANGE_END,
  SINGLE_LINE,
  BENCHMARK_INDICATOR
}

export enum LINE_STYLE {
  DOTTED,
  SOLID
}

export enum CHART_DATA_VALUE_TYPE {
  NUMBER,
  CURRENCY,
  PERCENTAGE
}

export enum ALIGN_TYPE {
  LEFT,
  RIGHT,
  TOP,
  BOTTOM
}

/********** Color Constants ***************************/

export enum COLOR_PALETTE {
  CATEGORICAL,
  VALUE,
  PERFORMANCE,
  ALL,
  CUSTOM
}

export enum DATA_VISUALIZATION_ACCENT_HUE {
  ALERT,
  ATTENTION,
  CAUTION,
  WARNING
}

export const DATA_VISUALIZATION_ACCENT_HUE_COLOR = {
  [DATA_VISUALIZATION_ACCENT_HUE.ALERT]: 'var(--uui-color-dataviz-red)',
  [DATA_VISUALIZATION_ACCENT_HUE.ATTENTION]: 'var(--uui-color-dataviz-pink)',
  [DATA_VISUALIZATION_ACCENT_HUE.CAUTION]: 'var(--uui-color-dataviz-yellow)',
  [DATA_VISUALIZATION_ACCENT_HUE.WARNING]: 'var(--uui-color-dataviz-orange)'
};

export enum COLOR_PALETTE_CONTRAST {
  SUBTLE,
  DEFAULT,
  HIGH
}

export enum DATA_VISUALIZATION_HUE_VARIANT {
  AQUA,
  TEAL,
  MARINE,
  COBALT,
  BLUE,
  PLUM,
  MAGENTA,
  PINK,
  RED,
  ORANGE,
  YELLOW,
  LIME,
  GREEN,
  GRAY
}

export const DATA_VISUALIZATION_HUE = {
  [DATA_VISUALIZATION_HUE_VARIANT.AQUA]: 'var(--uui-color-dataviz-aqua)',
  [DATA_VISUALIZATION_HUE_VARIANT.TEAL]: 'var(--uui-color-dataviz-teal)',
  [DATA_VISUALIZATION_HUE_VARIANT.MARINE]: 'var(--uui-color-dataviz-marine)',
  [DATA_VISUALIZATION_HUE_VARIANT.COBALT]: 'var(--uui-color-dataviz-cobalt)',
  [DATA_VISUALIZATION_HUE_VARIANT.BLUE]: 'var(--uui-color-dataviz-blue)',
  [DATA_VISUALIZATION_HUE_VARIANT.PLUM]: 'var(--uui-color-dataviz-plum)',
  [DATA_VISUALIZATION_HUE_VARIANT.MAGENTA]: 'var(--uui-color-dataviz-magenta)',
  [DATA_VISUALIZATION_HUE_VARIANT.PINK]: 'var(--uui-color-dataviz-pink)',
  [DATA_VISUALIZATION_HUE_VARIANT.RED]: 'var(--uui-color-dataviz-red)',
  [DATA_VISUALIZATION_HUE_VARIANT.ORANGE]: 'var(--uui-color-dataviz-orange)',
  [DATA_VISUALIZATION_HUE_VARIANT.YELLOW]: 'var(--uui-color-dataviz-yellow)',
  [DATA_VISUALIZATION_HUE_VARIANT.LIME]: 'var(--uui-color-dataviz-lime)',
  [DATA_VISUALIZATION_HUE_VARIANT.GREEN]: 'var(--uui-color-dataviz-green)',
  [DATA_VISUALIZATION_HUE_VARIANT.GRAY]: 'var(--uui-gray-05)'
};

export const DATA_VISUALIZATION_DEFAULTS = {
  CONTRAST: COLOR_PALETTE_CONTRAST.DEFAULT,
  ARC_THICKNESS: 24,
  RADIUS: 100,
  LEGEND_VALUE_SEPERATOR: '|',
  STROKE_COLOR: 'var(--uui-white)',
  EMPTY_SERIES_MESSAGE: 'No data provided',
  ACCENT_HUE: DATA_VISUALIZATION_ACCENT_HUE.ALERT
};

export const DEFAULT_COLOR: IChartColor = {
  palette: COLOR_PALETTE.ALL,
  contrast: COLOR_PALETTE_CONTRAST.DEFAULT,
  accentHue: DATA_VISUALIZATION_ACCENT_HUE.ALERT
};

export const BOXPLOT_LEGEND_DEFAULTS = {
  quartile: 'Upper/Lower Quartile (75th/25th percentile)',
  decile: 'Upper/Lower Decile (90th/10th percentile)',
  median: 'Median (50th percentile)'
};

// To show error message when empty configuration provided
export const CIRCULAR_CHART_INVALID_CONFIG = {
  type: CHART_TYPE.PIE,
  series: [],
  emptySeriesMessage: 'Invalid Configuration Provided'
};

export const BAR_CHART_INVALID_CONFIG = {
  type: CHART_TYPE.GROUPED_BAR,
  series: [],
  emptySeriesMessage: 'Invalid Configuration Provided'
};

export const LINE_CHART_INVALID_CONFIG = {
  type: CHART_TYPE.LINE,
  series: [],
  emptySeriesMessage: 'Invalid Configuration Provided'
};

export enum STACKED_BAR_CHART_TOOLTIP_BEHAVIOR {
  INDIVIDUAL,
  ISOLATED,
}

export const STACKED_BAR_CONSTANTS = {
  HIGH_DENSITY_THRESHOLD: 8,
}